import * as Sentry from '@sentry/react';
import { useMutation } from '@tanstack/react-query';
import { Policy } from 'models/policies';
import endpoint from 'shared/api';

import { AdjustPolicyDto } from '../models';

export const useUpdatePolicy = () => {
  const mutation = useMutation({
    mutationFn: async ({
      policyId,
      adjustPolicyDto,
    }: {
      policyId: string;
      adjustPolicyDto: AdjustPolicyDto;
    }): Promise<Policy> => {
      const { data } = await endpoint.network.patch(
        `/policies/${policyId}`,
        adjustPolicyDto
      );
      return data;
    },
    onError: (error, { policyId, adjustPolicyDto }) => {
      Sentry.captureException(error, {
        tags: {
          feature: 'ADJUST_POLICY',
        },
        extra: {
          policyId,
          adjustPolicyDto,
          description: `An error occurred while trying to update policy ${policyId}`,
        },
      });
    },
  });

  return mutation;
};
